import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Pareto from 'highcharts/modules/pareto';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Highcharts from "@material-ui/core/es/styles/withStyles";
import {convertSecondsToMinutesSecondsFormat} from "../../../common/Util";
import  CustomTheme  from "../../../common/CustomTheme";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);


var config = {
    chart: {
        type: 'column'
    },
    title: {
        text: 'Utilização diária'
    },
    xAxis: {
        categories: []
    },
    yAxis: [{
        min: 0,
        max: 16,
        title: {
            text: 'Total em horas'
        },
        stackLabels: {
            enabled: true,
            style: {
                fontWeight: 'bold',
                color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
            }
        }
    },
        {
            min: 0,
            title: {
                text: '# ciclos'
            },
            opposite: true
        }],
    legend: {
        align: 'center',
        x: -30,
        verticalAlign: 'bottom',
        y: 25,
        floating: true,
        backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
        borderColor: '#CCC',
        borderWidth: 1,
        shadow: false
    },
    tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'

    },
    plotOptions: {
        column: {
            stacking: 'normal',
            dataLabels: {
                enabled: false,
                color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
            }
        }
    },
    series: []
};

export default function TotalUsagePerDateChart(prop) {
    const { series } = prop;

    //console.log('series', series);

    if (series) {
        let categories = [];
        let dataHours = [];
        let dataCycles = [];

        series.map(i => {
            categories.push(i.Dia.substring(0,10));
            dataHours.push( Math.round( (i.TotalTempoCiclo / 60 / 60 * 10 ) ) / 10 );
            dataCycles.push( Math.round(i.Ciclos) );
        })

        config = {
            ...config,
            xAxis: {
                categories: categories
            },

            series: [
                {
                    name: 'Horas de uso',
                    data: dataHours,
                    color:  CustomTheme.colors.COLOR_chart_barra_utilizacao_serie_0
                },
                {
                    name: '# ciclos',
                    type: 'spline',
                    data: dataCycles,
                    yAxis: 1
                }

            ],
        }

    }


    return (
        <Card>
            <ReactHighcharts config = {config}>
            </ReactHighcharts>
        </Card>
    )
}
